import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { ErrorReportingService } from './error-reporting.service';

/**
 * ErrorHandler global (Fase 2 — Erros MVP).
 *
 * Captura erros NÃO tratados (runtime, promises rejeitadas, zone errors) e os
 * reporta ao ingest com payload sanitizado + stack truncada.
 *
 * Erros `HttpErrorResponse` são IGNORADOS aqui de propósito: os 5xx já são
 * reportados pelo `HttpErrorInterceptor` — reportar de novo
 * geraria duplicidade no ingest.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler
{
    constructor(private _reporting: ErrorReportingService)
    {
    }

    handleError(error: any): void
    {
        // Erros HTTP são tratados pelo HttpErrorInterceptor — nunca reportar
        // em dobro.
        if ( error instanceof HttpErrorResponse )
        {
            console.error(error);
            return;
        }

        try
        {
            this._reporting.reportUnhandledError(error);
        }
        catch ( reportError )
        {
            // O handler de erro NUNCA pode falhar por causa do próprio report
            // (evita loop de erros).
            console.error('Falha ao reportar erro não tratado:', reportError);
        }

        console.error(error);
    }
}